/* eslint-disable react/button-has-type */
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

import { selectSelectedAppKey } from '../../../../../../../scanline/redux/WebsiteExperimental/selectors';
import { detailsMap } from '../../../../content';

import './Unstyled.scss';

const VARIANT = 'unstyled';

const mapStateToProps = state => {
	const { websiteExperimental } = state;
	return {
		appKey: selectSelectedAppKey(websiteExperimental)
	};
};

const Unstyled = ({ appKey }) => {
	const obj = useMemo(() => detailsMap[appKey], [appKey]);
	return (
		<div className={`details-${VARIANT}-wrapper`}>
			<h2 className="title">{obj.title}</h2>
			<p className="body">{obj.details}</p>
			<div className="actions">
				<button>Schedule Free Trial</button>
			</div>
		</div>
	);
};

export default connect(mapStateToProps)(Unstyled);
